import type { MinimalSchoolWithOrg } from '@airreading/common/data';

export function SchoolWithDistrict({ school }: { school: MinimalSchoolWithOrg }) {
  return (
    <>
      {school.name} <em>({school.org.name})</em>
    </>
  );
}
